var _style, _g, _circle, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickleball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,55.118;}\r\n\t.st4{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,56.8883;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.5,600L305.5,600c26.4-26.4,42.3-61.7,44.5-99l7.3-124.6c3.1-53.4,25.8-103.7,63.6-141.5l124.4-124.4 c64.6-64.6,169.4-64.6,234,0l96.3,96.3c64.6,64.6,64.6,169.4,0,234L751.2,565.2c-37.8,37.8-88.2,60.4-141.5,63.6l-124.6,7.3 c-37.3,2.2-72.6,18-99,44.5l0,0L305.5,600z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.2,598L101.8,789.4c-2.8,2.8-2.5,7.8,0.8,11l83.1,83.1c3.3,3.3,8.2,3.6,11,0.8l191.4-191.4 c2.8-2.8,2.5-7.8-0.8-11l-83.1-83.1C301,595.5,296.1,595.1,293.2,598z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 360.6,
    y1: 718.7,
    x2: 235.1,
    y2: 656.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 308.5,
    y1: 770.8,
    x2: 183,
    y2: 708.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 256.5,
    y1: 822.9,
    x2: 131,
    y2: 760.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 592.4,
    cy: 834.4,
    r: 127.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 538.4,
    y1: 777.9,
    x2: 538.4,
    y2: 777.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 593.5,
    y1: 777.9,
    x2: 621,
    y2: 777.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 648.6,
    y1: 777.9,
    x2: 648.6,
    y2: 777.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 536.9,
    y1: 833.3,
    x2: 536.9,
    y2: 833.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 593.8,
    y1: 833.3,
    x2: 622.3,
    y2: 833.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 650.7,
    y1: 833.3,
    x2: 650.7,
    y2: 833.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 536.9,
    y1: 888.6,
    x2: 536.9,
    y2: 888.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 593.8,
    y1: 888.6,
    x2: 622.3,
    y2: 888.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 650.7,
    y1: 888.6,
    x2: 650.7,
    y2: 888.6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickleball);
export default __webpack_public_path__ + "static/media/Pickleball.4da4ab7c.svg";
export { ForwardRef as ReactComponent };